import React, { useState } from 'react';
const DistanceCenter = ({ center }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentImage, setCurrentImage] = useState('');

  const openModal = (image) => {
    setCurrentImage(image);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setCurrentImage('');
  };

  const iconStyle = {
    marginRight: '10px',
    color: '#1ab5f1',
    fontWeight: 'bolder',
    fontSize: '1.5em',
  };

  return (
    <div>
      <div className="banner-slide" style={{ height: '90vh', position: 'relative' }}>
        <img src={center.bannerImage} alt={`Transforming Lives at ${center.name}`} className="banner-image" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
        <div className="banner-content" style={{ color: 'white', position: 'absolute', bottom: '20px', left: '20px' }}>
          <h2>Transforming Lives at {center.name}</h2>
          <p>{center.description}</p>
        </div>
      </div>

      <section>
        <div className="auto-container">
          <div className="sec-title style-two">
           <h3 style={{ marginTop: '30px' }}>AMAS UNIVERSITY COLLEGE OF DISTANCE EDUCATION  {center.name.toUpperCase()} CAMPUS</h3>      </div>

          {/* Accredited Programs Section */}
          <div className="card" style={{ marginTop: '70px', padding: '20px', border: '1px solid #ccc', borderRadius: '8px', display: 'flex' }}>
            <div style={{ flex: 1 }}>
              <h3>ACCREDITED PROGRAMS</h3>
              <ul className="list">
                {center.programs.map((program, index) => (
                  <li key={index}>
                    <div className="icon-box">
                      <span className="flaticon-book" style={iconStyle}></span>
                      {program}
                    </div>
                  </li>
                ))}
              </ul>
            </div>
            <div style={{ flex: '0 0 150px', marginLeft: '20px' }}>
              <h4>CERTIFICATE OF ACCREDITATION</h4>
              {center.certifications.map((cert, index) => (
                <img 
                  key={index} 
                  src={cert.image} 
                  alt={`Accreditation ${index + 1}`} 
                  style={{ width: '150px', cursor: 'pointer', marginRight: '10px' }} 
                  onClick={() => openModal(cert.image)} 
                />
              ))}
            </div>
          </div>

          {/* Modal for Full Image */}
          {isModalOpen && (
            <div className="modal" style={modalStyle}>
              <span style={closeButtonStyle} onClick={closeModal}>&times;</span>
              <div style={modalContentStyle}>
                <img src={currentImage} alt="Accreditation Letter" style={imageStyle} />
              </div>
            </div>
          )}
        </div>
      </section>
    </div>
  );
}

// Simple modal styles
const modalStyle = {
  display: 'flex',
  position: 'fixed',
  zIndex: 100,
  left: 0,
  top: 0,
  width: '100%',
  height: '100%',
  backgroundColor: 'rgba(0, 0, 0, 0.8)',
  justifyContent: 'center',
  alignItems: 'center',
};

const modalContentStyle = {
  maxWidth: '90%',
  maxHeight: '80%',
  overflowY: 'auto',
};

const imageStyle = {
  width: '100%',
  height: 'auto',
  maxHeight: '100%',
};

const closeButtonStyle = {
  color: 'white',
  position: 'absolute',
  top: '20px',
  right: '40px',
  fontSize: '40px',
  fontWeight: 'bold',
  cursor: 'pointer',
};

export default DistanceCenter;